import { ICSSInJSStyle } from "@fluentui/react-northstar";

import { useFluentColorScheme } from "../../../shared/theme/useColorScheme";
import { useDeviceTesterStateContext } from "../../device-tester-context-provider/DeviceTesterContextProvider";
import { usePlatformTypeContext } from "../../platform-type-provider/PlatformTypeProvider";

interface ResultsFinishTestButtonStyles {
  actionButton: ICSSInJSStyle;
  finishTestText: ICSSInJSStyle;
}

export const useResultsFinishTestButtonStyles: () => ResultsFinishTestButtonStyles =
  () => {
    const { brand, white, main } = useFluentColorScheme();

    const { isMobile } = usePlatformTypeContext();
    const { deviceTesterState } = useDeviceTesterStateContext();

    if (isMobile) {
      return {
        actionButton: {
          backgroundColor: deviceTesterState.isInfoFetched
            ? brand.background
            : main.foregroundDisabled,
          color: white.foreground,
          borderRadius: "8px",
          height: "52px",
          width: "343px",
          border: "none",
        },

        finishTestText: {
          color: deviceTesterState.isInfoFetched
            ? white.foreground
            : main.backgroundDisabled,
        },
      };
    } else {
      return {
        actionButton: {
          backgroundColor: deviceTesterState.isInfoFetched
            ? brand.background
            : main.foregroundDisabled,
          color: white.foreground,
          borderRadius: "4px",
          height: "35px",
          width: "100px",
          border: "none",
        },

        finishTestText: {
          color: deviceTesterState.isInfoFetched
            ? white.foreground
            : main.backgroundDisabled,
        },
      };
    }
  };
